<div class="col-md-8">
    <div class="row">
        <div class="col-md-12">
            <div class="post-138 page type-page status-publish hentry">
                <div class="widget-main">
                    <div class="widget-inner">
                        <h3 class="archive-title" *ngIf="!isLoggedIn">Registrierung</h3>
                        <h3 class="archive-title" *ngIf="isLoggedIn">Profil bearbeiten</h3>

                        <form id="form" [formGroup]="formular" (ngSubmit)="speichern()" role="form"
                              class="form-horizontal register-form">
                            <div class="form-group">
                                <label class="col-sm-2 control-label">Email Adresse*</label>

                                <div class="col-sm-8">
                                    <input pInputText formControlName="email" class="ms-form-text" type="email"
                                           required="">
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.email.valid || formular.controls.email.untouched">
                                        Ungültige Email Adresse.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="!isLoggedIn">
                                <label class="col-sm-2 control-label">Passwort *</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="passwort" class="ms-form-text" type="password"
                                           value=""
                                           required="">
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.passwort.valid || formular.controls.passwort.untouched">
                                        Das Passwort muss mindestens 7 Zeichen enthalten.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="!isLoggedIn">
                                <label class="col-sm-2 control-label">Passwort bestätigen *</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="pwBestaetigen" class="ms-form-text"
                                           type="password"
                                           value=""
                                           required="">
                                    <div class="invalid-input"
                                         [hidden]="!formular.hasError('passwordValidator') || formular.controls.pwBestaetigen.untouched">
                                        Passwörter stimmen nicht überein.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Anrede *</label>
                                <div class="col-sm-8">
                                    <p-dropdown id="anrede"
                                                [ngClass]="formular.controls.anrede.invalid && formular.controls.anrede.touched ? 'invalid-dropdown' : 'half'"
                                                class="half" formControlName="anrede"
                                                [options]="anredeOptionen"/>
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.anrede.valid || formular.controls.anrede.untouched">
                                        Bitte wählen Sie einen Eintrag in der Liste.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Akad. Grad ***</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="akadGradVorangestellt" class="ms-form-text-short"
                                           type="text"
                                           placeholder="vorangestellt">
                                    <input pInputText formControlName="akadGradNachgestellt"
                                           class="ms-form-text-short add-margin-left"
                                           type="text"
                                           placeholder="nachgestellt">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Vorname *</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="vorname" class="ms-form-text" type="text"
                                           required="">
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.vorname.valid || formular.controls.vorname.untouched">
                                        Bitte füllen Sie dieses Feld aus.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Nachname *</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="nachname" class="ms-form-text" type="text"
                                           required="">
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.nachname.valid || formular.controls.nachname.untouched">
                                        Bitte füllen Sie dieses Feld aus.
                                    </div>
                                </div>
                            </div>

                            <div id="geburtstag" class="form-group" formGroupName="geburtsdatum">
                                <label class="col-sm-2 control-label">Geburtsdatum *</label>
                                <div class="col-sm-8">
                                    <!--p-inputNumber formControlName="geburtstag" maxlength="2"
                                                   placeholder="Tag" class="datum" [min]="1"
                                                   [max]="31" /-->
                                    <input pInputText formControlName="geburtstag" class="ms-form-text-date" type="text"
                                           required="" placeholder="Tag" minlength="1" maxlength="2">

                                    <p-dropdown id="monat" class="monat" formControlName="geburtsmonat"
                                                placeholder="Monat"
                                                [ngClass]="formular.controls.geburtsdatum.controls.geburtsmonat.invalid && formular.controls.geburtsdatum.controls.geburtsmonat.touched ? 'invalid-dropdown' : 'monat'"
                                                [options]="monate" scrollHeight="380px"/>
                                    <!--p-inputNumber formControlName="geburtsjahr" maxlength="4"
                                                   placeholder="Jahr" [useGrouping]="false" class="datum"/-->

                                    <input pInputText formControlName="geburtsjahr" class="ms-form-text-date"
                                           type="text"
                                           required="" placeholder="Jahr" minlength="4" maxlength="4">

                                    <div class="invalid-input"
                                         [hidden]="(!formular.controls.geburtsdatum.hasError('invalidDate') || formular.controls.geburtsdatum.controls.geburtsjahr.untouched)
                                                    && (formular.controls.geburtsdatum.controls.geburtstag.valid || formular.controls.geburtsdatum.controls.geburtstag.untouched)
                                                    && (formular.controls.geburtsdatum.controls.geburtsmonat.valid || formular.controls.geburtsdatum.controls.geburtsmonat.untouched)
                                                    && (formular.controls.geburtsdatum.controls.geburtsjahr.valid || formular.controls.geburtsdatum.controls.geburtsjahr.untouched)">
                                        Das Geburtsdatum ist kein gültiges Datum.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Adresse *</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="adresse" class="ms-form-text" type="text"
                                           placeholder="Straße, Hausnr.">
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.adresse.valid || formular.controls.adresse.untouched">
                                        Bitte geben Sie Ihre Adresse ein.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Adresszusatz</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="adresszusatz" class="ms-form-text" type="text"
                                           placeholder="Firmenname, Postfach, c/o, etc.">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Postleitzahl *</label>
                                <div class="col-sm-8">
                                    <input pInputText type="text" formControlName="plz" maxlength="5"
                                           class="ms-form-text"/>
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.plz.valid || formular.controls.plz.untouched">
                                        Die Postleitzahl muss 4 Ziffern lang sein.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Ort *</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="ort" class="ms-form-text" type="text">
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.ort.valid || formular.controls.ort.untouched">
                                        Bitte geben Sie einen Ort ein.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Bundesland *</label>
                                <div class="col-sm-8">
                                    <p-dropdown id="bundesland" formControlName="bundesland"
                                                [options]="bundeslandOptionen"
                                                [ngClass]="formular.controls.bundesland.invalid && formular.controls.bundesland.touched ? 'invalid-dropdown' : ''"
                                                scrollHeight="290px"/>
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.bundesland.valid || formular.controls.bundesland.untouched">
                                        Bitte wählen Sie Ihr Bundesland aus.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Telefonnummer (Festnetz) **</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="festnetz" class="ms-form-text" type="text"
                                           placeholder="0043XXXXXXXX" minlength="10">
                                    <div class="invalid-input"
                                         [hidden]="!formular.hasError('phoneNumberValidator') || formular.controls.festnetz.untouched">
                                        Bitte geben Sie mindestens eine Telefonnummer ein.
                                    </div>
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.festnetz.valid || formular.controls.festnetz.untouched">
                                        Geben Sie bitte eine gültige Ländervorwahl und Festnetznummer ein.
                                    </div>
                                    <div class="are-you-sure-input"
                                         [hidden]="formular.hasError('phoneNumberValidator') || formular.controls.festnetz.getRawValue()?.length == 0 || formular.controls.festnetz.invalid || formular.controls.festnetz.getRawValue()?.startsWith('0043')">
                                        Sind Sie sicher, dass die Nummer korrekt ist?
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Telefonnummer (Mobil) **</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="mobil" class="ms-form-text" type="text"
                                           placeholder="0043XXXXXXXX" minlength="10">
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.mobil.valid || formular.controls.mobil.untouched">
                                        Geben Sie bitte eine gültige Ländervorwahl und Handynummer ein.
                                    </div>
                                    <div class="are-you-sure-input"
                                         [hidden]="formular.hasError('phoneNumberValidator') || formular.controls.mobil.getRawValue()?.length == 0 || formular.controls.mobil.invalid || formular.controls.mobil.getRawValue()?.startsWith('0043') || formular.controls.mobil.untouched">
                                        Sind Sie sicher, dass die Nummer korrekt ist?
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Berufsgruppe *</label>
                                <div class="col-sm-8">
                                    <p-dropdown id="berufsgruppe" formControlName="berufsgruppe"
                                                [ngClass]="formular.controls.berufsgruppe.invalid && formular.controls.berufsgruppe.touched ? 'invalid-dropdown' : ''"
                                                [options]="berufOptionen"/>
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.berufsgruppe.valid || formular.controls.berufsgruppe.untouched">
                                        Bitte wählen Sie einen Eintrag in der Liste.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="istArzt">
                                <label class="col-sm-2 control-label">Fachrichtung ***<br></label>
                                <div class="col-sm-8">
                                    <p-listbox id="fachrichtung" formControlName="fachrichtung" [options]="fachrichtungOptionen"
                                               [multiple]="true"/>
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.fachrichtung.valid || !istFachrichtungTouched">
                                         {{fachrichtungInvalidMessage}}
                                    </div>
                                    <small>(Mehrfachauswahl möglich)</small>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="istArzt">
                                <label class="col-sm-2 control-label">ÖÄK-Arztnummer ***</label>
                                <div class="col-sm-8">
                                    <p-inputMask id="arztnummer" mask="99999-99" formControlName="arztnummer"
                                                 placeholder="00000-00"
                                                 [ngClass]="formular.controls.arztnummer.invalid && formular.controls.arztnummer.touched ? 'invalid-inputMask' : 'arztnummer'"/>
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.arztnummer.valid || formular.controls.arztnummer.untouched">
                                        Bitte geben Sie Ihre ÖÄK-Arztnummer ein.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Derzeit tätig als Gutachter/in
                                    für*</label>
                                <div class="col-sm-8">
                                    <p-listbox id="gutachter" formControlName="gutachterFuer" [options]="gutachterTaetigkeitOptionen"
                                               [multiple]="true"/>
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.gutachterFuer.valid || !istGutachterTouched">
                                         {{gutachterInvalidMessage}}
                                    </div>
                                    <small>(Mehrfachauswahl möglich)</small>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="!isLoggedIn">
                                <label class="col-sm-2 control-label">
                                    <p-checkbox id="checkbox" class="checkbox" formControlName="einverstaendnis"
                                                [binary]="true"></p-checkbox>
                                </label>
                                <div class="col-sm-8">
                                    Ich erkläre mich einverstanden, dass meine Daten elektronisch
                                    gespeichert und im AbsolventenInnenverzeichnis der ÖBAK vermerkt werden.<br>
                                    Das AbsolventenInnenverzeichnis steht den Trägern der
                                    Sozialversicherung als Pool der GutachterInnen zur Verfügung. Dieses
                                    Einverständnis kann jederzeit schriftlich widerrufen werden.
                                    <div class="invalid-input"
                                         [hidden]="formular.controls.einverstaendnis.valid || formular.controls.einverstaendnis.untouched">
                                        Bitte akzeptieren Sie das Einverständnis zur Datenspeicherung.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div>
                                    <input [disabled]="!formular.valid" class="btn btn-primary" type="submit"
                                           value="Absenden" *ngIf="!isLoggedIn">
                                    <input id="submitBtn"
                                           [disabled]="formular.invalid"
                                           class="btn btn-primary" type="submit"
                                           value="Speichern" *ngIf="isLoggedIn">
                                </div>
                            </div>

                        </form>
                        <div class="form-footer">
                            <span class="footer-stars">*</span>Pflichtfeld<br>
                            <span class="footer-stars">**</span>Bitte mind. eine Telefonnummer angeben<br>
                            <span class="footer-stars">***</span>Bitte angeben, wenn Sie der Berufsgruppe "Arzt"
                            angehören.
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
